import {Component, EventEmitter, Input, OnInit, Optional, Output, Self} from '@angular/core';
import {FormBuilder, FormGroup, NgControl, ValidatorFn, Validators} from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { AlertBarService } from 'src/app/services/alert-bar/alert-bar.service';
import { ApiService } from 'src/app/services/api/api.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { SessionService } from 'src/app/services/session/session.service';
import { FieldValidators } from 'src/app/Validators/field-validators';

@Component({
  selector: 'app-step-for-password',
  templateUrl: './step-for-password.component.html',
  styleUrls: ['./step-for-password.component.scss'],
})
export class StepForPasswordComponent implements OnInit {
  forFormGroup!: FormGroup;
  title: any;
  urlReturn: any;

  @Input() letters?: number;
  @Input() minLength?: number;
  @Input() numbers?: number;
  specialCharacter?: number = 0;

  @Output() onFocus = new EventEmitter<void>(true);
  @Output() onBlur = new EventEmitter<void>(true);
  @Output() onChange = new EventEmitter<string>(true);

  showPassword = false;
  showPasswordConfirm = false;
  lettersValid = false;
  minLengthValid = false;
  numbersValid = false;
  specialCharacterValid = true;

  private _controlValidators?: ValidatorFn[];
  userData: any = [];
  isNumber: any;
  isLetter: any;
  isMin: any;
  isSpecial: any = true;
  textBtn: any;
  update!: boolean;

  constructor(
    private fb: FormBuilder,
    @Self() @Optional() public ngControl: NgControl,
    private route: Router,
    private gf: GlobalService,
    private storage: LocalStorageService,
    private api: ApiService,
    private loader: LoadingService,
    private toast: AlertBarService,
    public session: SessionService,
    public routeActive: ActivatedRoute,
    private gtmService: GoogleTagManagerService
  ) {
    // this.loader.stopLoading()
    if (ngControl) {
      ngControl.valueAccessor = null;
    }

    this.routeActive.data.subscribe((res: any) => {
      this.textBtn = res.textBtn;
      this.update = res.update;
    });

    this.loader.stopLoading();
  }

  ngOnInit(): void {

    this.userData =  this.session.getUserData()

    if(this.update){

      const urlReturn = this.storage.get('urlReturn')

      if (urlReturn) {
        this.urlReturn = urlReturn;
      }

   

    }

    this.forFormGroup = this.fb.group({
      Senha: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          FieldValidators.password,
        ]),
      ],
      SenhaConfirmacao: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          FieldValidators.equals('Senha', 'Senha não confere com a escolhida'),
        ]),
      ],
    });
  }

  onSubmit() {
    if (this.forFormGroup.status == 'VALID') {
      this.loader.startLoading();

      this.api
        .query(
          'cliente/Senha',
          {
            Request: {
              Password: this.forFormGroup.value.Senha,
              CPF: this.userData.CPF,
              Voucher: this.userData.voucher,
            },
          },
          'post'
        )
        ?.subscribe(
          (data: any) => {
            if (data.Sucesso) {

              if(this.userData){

                if (data) {

                  this.loader.stopLoading();
                  console.log(this.update)

                  if(this.update){

                    this.storage.remove('urlReturn');
                    this.route.navigate([this.urlReturn]);
                    this.toast.openAlert('Senha alterada com sucesso!', '');

                  }else{
                    this.toast.openAlert('Senha cadastrada com sucesso!', '');
                    this.gtmService.push({
                      event: "signUpComplete"
                    });
                    this.route.navigate(['/login']);
                    this.gf.toTop();
                  }

                } 
                // else {
                  
                //   this.loader.stopLoading();
                // }

              }
             

            } else {
              this.loader.stopLoading();
              this.toast.openAlert(data.Mensagem, 'error');
              this.gf.toTop();
            }
          },
          (err) => {
            this.loader.stopLoading();
            this.toast.openAlert(
              'Houve um erro ao processar a solicitação!',
              'error'
            );
            this.gf.toTop();
          }
        );
    } else {
      this.loader.stopLoading();
      this.toast.openAlert('Formulário Inválido!', 'error');
      this.gf.toTop();
    }
  }

  onReset() {
    this.forFormGroup.reset();
  }

  handleChangeEvent(value: any): void {
    let pass = value.target.value;

    if (/^(?=(?:.*?[a-zA-Z]){1})/.exec(pass)) {
      this.isLetter = true;
    } else {
      this.isLetter = false;
    }
    if (/^(?=(?:.*?[0-9]){1})/.exec(pass)) {
      this.isNumber = true;
    } else {
      this.isNumber = false;
    }
    if (
      /^(?=(?:.*?[!@#$%*()_+^&}{:;?.]){1})(?!.*\s)[0-9a-zA-Z!@#;$%*(){}_+^&]/.exec(
        pass
      ) &&
      pass.length > 0
    ) {
      this.isSpecial = true;
    } else {
      this.isSpecial = false;
    }
    if (pass.length >= 8) {
      this.isMin = true;
    } else {
      this.isMin = false;
    }
  }
}
